<script>
import { toRefs } from '@vue/composition-api'
import { reactiveFormatRelativeTimeAgo } from '@/infrastructure/dates/dateFormatting'
import FeedbackReplyForCreatorListItem from '@/infrastructure/userFeedbacks/components/FeedbackReplyForCreatorListItem'

export default {
  components: { FeedbackReplyForCreatorListItem },
  props: {
    createdOn: { type: String, required: true },
    message: { type: String, required: true },
    replies: { type: Array },
  },

  setup(props) {
    const createdOnRelativeTimeAgo = reactiveFormatRelativeTimeAgo(toRefs(props).createdOn)

    return {
      createdOnRelativeTimeAgo,
    }
  },
}
</script>

<template>
  <v-card>
    <v-card-subtitle class="d-flex align-center">
      <div>{{ createdOnRelativeTimeAgo }}</div>
    </v-card-subtitle>

    <v-card-title class="py-0 text-pre-line" style="word-break: break-word">
      <i>{{ message }}</i>
    </v-card-title>

    <div class="pa-5">
      <v-expansion-panels v-if="replies && replies.length > 0">
        <v-expansion-panel>
          <v-expansion-panel-header> {{ replies.length }} replies</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list two-line class="pa-0 ma-0">
              <template v-for="(reply, i) in replies">
                <v-divider v-if="i > 0" :key="`divider-${i}`" />

                <FeedbackReplyForCreatorListItem
                  :key="reply.replyId"
                  :user-full-name="reply.userFullName"
                  :reply-time="reply.replyTime"
                  :message="reply.message"
                  class="pa-0 ma-0"
                />
              </template>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card v-else>
        <v-card-text>No replies yet</v-card-text>
      </v-card>
    </div>
  </v-card>
</template>
